import { SignalConnection } from 'typed-signals';

import { Shared } from '../App';
import { StatsBarWidget } from './StatsBarWidget';
import { Widget } from './Widget';

export interface VehicleStats
{
    speed: number,
    flipSpeed: number,
    handling: number,
    bounce: number
}

export class StatsWidget extends Widget
{
    public bars: [StatsBarWidget, StatsBarWidget, StatsBarWidget, StatsBarWidget];
    private onBuildConnection?: SignalConnection;

    constructor()
    {
        super();

        this.bars = [
            new StatsBarWidget(0),
            new StatsBarWidget(1),
            new StatsBarWidget(2),
            new StatsBarWidget(3),
        ];

        this.bars.forEach((bar, i) =>
        {
            this.view.addChild(bar.view);
            bar.view.y = 40 * i;
        });
    }

    protected async onOpen(): Promise<void>
    {
        this.onBuildConnection = Shared.game.vehicle.onBuild.connect(() => this.refresh(true));
        this.refresh(false);

        for (const bar of this.bars)
        {
            bar.open();
        }
    }

    protected async onClose(): Promise<void>
    {
        this.onBuildConnection?.disconnect();
        this.onBuildConnection = undefined;

        for (const bar of this.bars)
        {
            await bar.close();
        }
    }

    protected refresh(animated = false): void
    {
        const vehicle = Shared.game.vehicle;

        this.bars[0].setValue('rideStudioStats_maxSpeed', vehicle.calculateSpeed(), animated);
        this.bars[1].setValue('rideStudioStats_flipSpeed', vehicle.calculateFlipSpeed(), animated);
        this.bars[2].setValue('rideStudioStats_handling', vehicle.calculateHandling(), animated);
        this.bars[3].setValue('rideStudioStats_bounce', vehicle.calculateBounce(), animated);
    }
}
